<template>
  <div class="sync">
    <div class="sync__header">
      <div style="width:48%; display: inline-block;">
        <div class="sync__header__logo-and-title">
          <p class="sync__title">
            <font-awesome-icon
              class="sync__status__icons"
              title="Current Sync State"
              :icon="['custom', 'sync-general-icon']"
            />
            <strong
              class="g-text"
            >
              {{ $t('messages.syncManager.title') }}
            </strong>
          </p>
        </div>
        <div class="sync__header__logo-and-title">
          <p class="sync__title">
            <font-awesome-icon
              v-if="ConnectionInformation"
              class="g-text sync__status__icon "
              title="Current Sync State"
              :class="{'g-text--green': ConnectionInformation.message === 'Synced'}"
              :icon="['custom', ConnectionInformation.icon]"
            />
            <strong
              :class="{'g-text--green': ConnectionInformation.message === 'Synced'}"
              class="g-text"
            >
              {{ $t(`messages.header.${ConnectionInformation.code}`) }}
            </strong>
          </p>
        </div>
      </div>
      <div style="width:48%; display: inline-block; float: right; text-align: center;">
        <div
          v-if="ShowWarning === true"
          class="sync__header__warn"
        >
          <p class="warning">
            This will set the controller to Program mode.<br>
            After syncing, the interface will re-load.
          </p>
          <p>
            Are you sure?
            <button
              class="sync__header__warn--button g-btn g-btn g-btn--rounded g-btn--blue"
              @click="ChangeCtrlMode(true)"
            >
              YES
            </button>
            <button
              class="sync__header__warn--button g-btn g-btn g-btn--rounded g-btn--blue"
              @click="ChangeCtrlMode(false)"
            >
              NO
            </button>
          </p>
        </div>
        <!-- <h4 
          id="info"
        >
          {{ $tc('messages.syncManager.warningsAndInformation') }}
        </h4> -->
        <p
          v-for="(info, index) in information"
          :key="index" 
          class="warning"
        >
          {{ info }}
        </p>
      </div>
      <div
        v-if="SyncArray && SyncArray.length"
        class="sync__header__button"
      >
        <span>
          {{ $t('messages.syncManager.showTime') }}
          <span
            class="g-btn g-btn--toggle g-btn--rounded"
            :class="{'active': timeToggled}"
            @click="toggleTime"
          />
        </span>
        <button
          v-if="Syncing === true"
          type="button"
          class="developer-export-test g-btn g-btn g-btn--rounded g-btn--blue disabled"
          @click="SyncAll()"
        >
          {{ $tc('messages.syncManager.syncStatus', syncProgressValue) }}
        </button>
        <button
          v-else
          type="button"
          class="developer-export-test g-btn g-btn g-btn--rounded g-btn--blue"
          @click="SyncAll()"
        >
          <font-awesome-icon
            :title="$tc('messages.syncManager.currentSyncStateTitle')"
            :icon="['fa', 'sync-alt']"
          />
          {{ $tc('messages.syncManager.syncStatus', syncProgressValue) }}
        </button>
      </div>
      <!-- <div
        v-if="information.length"
        class="sync__header__warn"
      > -->
      <!-- <hr>
        <h4 
          id="info"
        >
          {{ $tc('messages.syncManager.warningsAndInformation') }}
        </h4>
        <p
          v-for="(info, index) in information"
          :key="index" 
          class="warning"
        >
          {{ info }}
        </p>  -->
      <!-- </div> -->
    </div>
    <div class="sync__sync-list-wrapper">
      <ol class="sync__sync-list">
        <li
          :class="{'sync__sync-list__row--time': timeToggled}"
          class="sync__sync-list__row sync__sync-list__row--title-header"
        >
          <strong>{{ $t('messages.syncManager.section') }}</strong>
          <strong
            v-if="timeToggled"
          >
            {{ $t('messages.syncManager.web') }}
          </strong>
          <span class="flex-row">
            <font-awesome-icon
              class="sync__status-icon"
              title="Current Sync State"
              :icon="['custom', 'select-all']"
              @click.stop="SelectAll(false,false)"
            />
            <font-awesome-icon
              class="sync__status-icon"
              title="Current Sync State"
              :icon="['custom', 'sync-all-from-web']"
              @click.stop="SelectAll(true,false)"
            />
            <font-awesome-icon
              class="sync__status-icon"
              title="Current Sync State"
              :icon="['custom','sync-all-from-controller']"
              @click.stop="SelectAll(false,true)"
            />
          </span>
          <strong
            v-if="timeToggled"
          >
            {{ $t('messages.syncManager.controller') }}
          </strong>
        </li>
      </ol>
      <div
        v-if="SyncArray.length === 0"
        class="sync__spinner"
      />
      <ol class="sync__sync-list">
        <li
          v-for="(syncItem, index) in SyncArray"
          :key="index"
          :class="{'sync__sync-list__row--time': timeToggled}"
          class="sync__sync-list__row"
        >
          <div>
            <div>
              <strong>{{ $t(`messages.syncManager.${syncItem.sectionid}`) }}</strong>
            </div>
            <slot
              v-if="timeToggled"
            >
              <div>{{ syncItem.synchronizedtimeConverted.date }}</div>
              <div>{{ syncItem.synchronizedtimeConverted.time }}</div>
            </slot>
          </div>
          <div
            v-if="timeToggled"
          >
            <div>{{ syncItem.appchangedtimeConverted.date }}</div>
            <div>{{ syncItem.appchangedtimeConverted.time }}</div>
          </div>
          <div class="flex-row">
            <span
              class="checkbox_container"
              title="Sync from Web data"
            >
              <label>
                <input
                  :id="['showA' + index]"
                  v-model="syncItem.checkedWeb"
                  type="checkbox"
                  title="Sync from Web data"
                  @click="CheckBoxA(index)"
                >
                <span class="checkmark" />
              </label>
            </span>
            <span
              class="sync__status-wrapper"
              :class="syncState(syncItem.actionIcon).color"
            >
              <font-awesome-icon
                class="sync__status-icon"
                title="Current Sync State"
                :icon="['custom', syncState(syncItem.actionIcon).icon]"
              />
            </span>
            <span
              class="checkbox-wrapper"
              title="Sync from Controller data"
            >
              <label>
                <input
                  :id="['showB' + index]"
                  v-model="syncItem.checkedCtrl"
                  type="checkbox"
                  title="Sync from Controller data"
                  @click="CheckBoxB(index)"
                >
                <span class="checkmark" />
              </label>
            </span>
          </div>
          <div
            v-if="timeToggled"
          >
            <div>{{ syncItem.ctrlchangedtimeConverted.date }}</div>
            <div>{{ syncItem.ctrlchangedtimeConverted.time }}</div>
          </div>
        </li>
      </ol>
    </div>
    
    <div
      v-if="SyncArray.length === 0"
      class="sync-modal__spinner"
    />
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import moment from 'moment'
import $ from 'jquery'

export default {
  name: 'SyncModal',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ConnectionInformation: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      information: [],
      timeToggled: false,
      SyncCapabilities: [],
      SyncArray: [],
      Syncing: false,
      CtrlWarn: false,
      ShowWarning: false,
      syncProgress: [
        'in progress',
        'now'
      ],
      syncProgressValue: 1,  // used to fill in synProgress array value, not truthiness value -jimm
      visibleToggleFlag: false,
      syncIcons: [
        {
          icon: 'sync-no-change',
          color: ''
        }, {
          icon: 'sync-recommended-web-to-controller',
          color: ''
        }, {
          icon: 'sync-recommended-controller-to-web',
          color: ''
        }, {
          icon: 'sync-recommended-web-to-controller',
          color: 'warning'
        }, {
          icon: 'sync-recommended-controller-to-web',
          color: 'warning'
        }, {
          icon: 'sync-manual-inverse-from-wc-to-cw',
          color: ''
        }, {
          icon: 'sync-manual-inverse-from-cw-to-wc',
          color: ''
        }, {
          icon: 'sync-manual-inverse-from-wc-to-cw',
          color: 'warning'
        }, {
          icon: 'sync-manual-inverse-from-cw-to-wc',
          color: 'warning'
        }, {
          icon: 'sync-manual-inverse-from-cw-to-wc',
          color: ''
        }, {
          icon: 'sync-manual-inverse-from-wc-to-cw',
          color: ''
        }
      ],
    }
  },
  watch: {
    SocketMessage(Msg) {
      const errorList = [
        'E42:01',
        'E42:02',
        'E42:03',
        'E42:04',
        // 5 is special case
        'E42:06',
        'E42:07',
        'E42:08',

        'EF1:02',

        'W24:00',
        'W24:02',
        'W24:03',
        'W24:04',
        'W24:05',
        'W24:06',
        'IFE'
      ]

      // console.log('%c<-- ' + JSON.stringify(Msg.data), 'color: blue')

      if(Msg && Msg.data && Msg.data.category === 'server') {

        if(Msg.data.command && Msg.data.command === 'info' && Msg.data.data && Msg.data.data.code) {
          if(errorList.includes(Msg.data.data.code))
            this.information.push(this.$t(`messages.syncManager.${Msg.data.data.code}`))
  
          if(Msg.data.data.code.split(':')[0] === 'I23')
            this.information.push(this.$t(`messages.syncManager.I23`, {percentage: Msg.data.data.code.split(':')[1]}))
          
          if(Msg.data.data.code.split(':')[0] === 'E42' && Msg.data.data.code.split(':')[1] === '05')
            this.information.push(this.$t(`messages.syncManager.E42:05`, {name: Msg.data.data.code.split(':')[2]}))
          
          if(Msg.data.data.code.split(':')[0] === 'W24' && Msg.data.data.code.split(':')[1] === '00')
            this.information.push(this.$t(`messages.syncManager.W24:00`, {name: Msg.data.data.code.split(':')[2]}))
        }
      } 

      if(Msg && Msg.data && Msg.data.component && Msg.data.component === 'SyncModal') {
        this.SyncCapabilities = Msg.data.Capabilities
        if(this.SyncCapabilities.ctrlWarn) {
          this.CtrlWarn = this.SyncCapabilities.ctrlWarn
          console.warn(this.CtrlWarn)
        }
      }
      if(Msg && Msg.data && Msg.data.category && Msg.data.category === 'server' && Msg.data.command && Msg.data.command === 'info' && Msg.data.data && Msg.data.data.code && Msg.data.data.code === 'I01:01') {
        // this.information.push(this.$t(`messages.syncManager.I01:01`))
        if( this.Syncing === true ) {
          this.Syncing = false
          window.syncing = false
          this.SyncDisableClick(this.Syncing)
        }
      }
      if(Msg && Msg.data && Msg.data.category && Msg.data.category === 'server' && Msg.data.command && Msg.data.command === 'synchronize' && Msg.data.data && Msg.data.data.status && Msg.data.data.status === 'OK') {
        this.information.push(this.$t(`messages.syncManager.syncOK`))
        this.$router.push('home')
        if( this.Syncing === true ) {
          this.Syncing = false
          window.syncing = false
          this.SyncDisableClick(this.Syncing)

        }
      }
      if(Msg && Msg.data && Msg.data.data && Msg.data.data.item && Msg.data.data.item === 'TimeStamps') {
        // console.log('Msg.data.data.item === TimeStamps, fill in Sync data from Msg')
        // console.log(JSON.stringify(Msg.data.data.record))
        if(Msg.data.data.record === undefined || Object.keys(Msg.data.data.record).length == 0 || JSON.stringify(Msg.data.data.record) === '[{}]') {
          // console.log('******** Msg.data.data.record is empty! we ignore it')
        } else {
          // console.log(JSON.stringify(this.SyncArray))
          // console.log(JSON.stringify(Msg.data.data.record))
          //if SyncArray is empty
          if(!this.SyncArray.length) {
            // console.log('SyncArray is empty, add Msg.data.data.record then run ConvertSyncArray()')
            this.SyncArray = Msg.data.data.record
            this.ConvertSyncArray(this.SyncArray, null, (err, rtn) => {
              if(err) {
                console.error(err)
              } else {
                this.SyncArray = rtn
                this.syncProgressValue = 1 // reset sync button to 'sync now'
                this.SyncDisableClick(this.Syncing)
              }
            })
          } else { // if SyncArray is populated we merge the new data into it
            // console.log('SyncArray is *not* empty, run MergeSyncArray() with incoming Msg.data.data.record Sync data (see above) ')
            // console.log('overwriting active web->controller sync choice??? ')
            this.MergeSyncArray(Msg.data.data.record, this.SyncArray, (err, rtn) => {
              if(err)
                console.error(err)
              else if(Msg.data && Msg.data.data && Msg.data.data.record && Msg.data.data.record[0] && Msg.data.data.record[0].sectionName !== undefined) {
                this.SyncArray = rtn
                this.syncProgressValue = 1 // reset sync button to 'sync now'
                this.SyncDisableClick(this.Syncing)
              }
            })
          }
        }

      }
    }
  },
  mounted() {
    this.syncProgressValue = 0 // set sync button to 'sync in progress'
    this.SocketMessageSend({category: 'data', command: 'get', data: {'type': 'dataset', 'item': 'TimeStamps'}})
    let Msg = { category: 'server', command: 'synchronize', data: { 'type': 'initiate' } }
    // console.log('%c--> ' + JSON.stringify(Msg), 'color: purple')
    this.SocketMessageSend( Msg )
  },
  methods: {
    toggleTime() {
      this.timeToggled = !this.timeToggled
    },
    TimeVisibleToggle() {
      //hide sync-list__row 3rd, 7th, and 8th children
      var op = (this.visibleToggleFlag) ? 0 : 1
      $('.visibleToggle').stop().animate({'opacity': op}, 100)

      // switch the toggle flag value
      this.visibleToggleFlag = !this.visibleToggleFlag
    },
    ChangeCtrlMode(Boolean) {
      this.ShowWarning = false
      if(Boolean) {
        this.information = []
        this.SyncAll(Boolean)
      } else {
          window.syncing = false
      }
    },
    syncState(value) {
      return this.syncIcons[value]
    },
    SyncDisableClick(Bool) {
      if(this.Syncing === true) {
        $('.sync-list').css('opacity', '0.4')
        $(':checkbox').prop('disabled', true)
      } else {
        $('.sync-list').css('opacity', '1')
        $(':checkbox').prop('disabled', false)
      }
    },
    SyncAll(Boolean) {

        // prevent user from closing modal window while syncing
        window.syncing = true

      let CtrlWarnCopy = this.CtrlWarn
      if(Boolean)
        this.CtrlWarn = !Boolean
      if(this.CtrlWarn === false) {
        this.Syncing = true
        this.syncProgressValue = 0  //  set sync button to 'sync in progress'
        this.SyncDisableClick(this.Syncing)

        let Msg = { category: 'server', command: 'synchronize', data: { type: 'execute' } }
        this.SocketMessageSend( Msg )

        this.CtrlWarn = CtrlWarnCopy
      } else {
        this.ShowWarning = true
      }
    },
    SelectAll(UseApp, UseCtrl) {
      if(this.Syncing === false) {
        let SectionId = this.SyncCapabilities.sections
        
        let Msg = { component: 'SyncModal', command: 'SelectAll', data: { useApp: UseApp, useCtrl: UseCtrl, sectionIds: SectionId } }
        console.log('%c--> ' + JSON.stringify(Msg), 'color: purple')
        this.SocketMessageSend( Msg )
      }
    },
    /**
    *  \brief  Converts data and adds fields that we need for SyncAraay
    *  \param   Array, Callback
    *  \return  Callback array
    */
    ConvertSyncArray(array, initArray, Callback) {
      let newArray = []
      // console.log('ConvertSyncArray(array) ' + JSON.stringify(array))
      // console.log('ConvertSyncArray(initArray) ' + JSON.stringify(initArray))

      array.forEach((element, index) => {
        element.sectionName = this.SyncCapabilities.sections[element.sectionid]
        if(element.sectionid && element.sectionName) {
          const format = this.ModalData.store.getData('settings.time.currentFormat').split(', ')
          const dateFormat = format[0]
          const timeFormat = format[1]

          const getDateTime = (seconds) => {
            return {
              date: moment(seconds * 1000).utc().format(dateFormat),
              time: moment(seconds * 1000).utc().format(timeFormat)
            }
          }

          Object.assign(element, {
            appchangedtimeConverted: getDateTime(element.appchangedtime),
            ctrlchangedtimeConverted: getDateTime(element.ctrlchangedtime),
            synchronizedtimeConverted: getDateTime(element.synchronizedtime),
            initialState: {
              useappdata: '',
              warning: '',
              usectrldata: ''
            },
            actionIcon: 0,
            actionIconArray: [],
            actionIconInitArray: []
          })
          if(element.useappdata === '0') {
            element['checkedWeb'] = false
            element.actionIconArray.push(0)
            element.initialState.useappdata = false
            element.actionIconInitArray.push(0)
          } else if(element.useappdata === '1') {
            element['checkedWeb'] = true
            element.actionIconArray.push(1)
            element.actionIconInitArray.push(1)
            element.initialState.useappdata = true
          } else {
            element['checkedWeb'] = false
            element.actionIconArray.push(0)
            element.actionIconInitArray.push(0)
            element.initialState.useappdata = false
          }
          if(element.warning === '1') {
            element.initialState.warning = true
            element.actionIconArray.push(1)
            element.actionIconInitArray.push(1)
          } else {
            element.initialState.warning = false
            element.actionIconArray.push(0)
            element.actionIconInitArray.push(0)
          }
          if(element.usectrldata === '0') {
            element['checkedCtrl'] = false
            element.actionIconArray.push(0)
            element.actionIconInitArray.push(0)
            element.initialState.usectrldata = false
          } else if(element.usectrldata === '1') {
            element['checkedCtrl'] = true
            element.actionIconArray.push(1)
            element.actionIconInitArray.push(1)
            element.initialState.usectrldata = true
          } else {
            element['checkedCtrl'] = false
            element.actionIconArray.push(0)
            element.actionIconInitArray.push(0)
            element.initialState.usectrldata = false
          }
          if(initArray === null) {
            element.actionIcon = this.CalculateIconState(element.actionIconArray, element.actionIconInitArray)
          } else {
            element.actionIcon = this.CalculateIconState(element.actionIconArray, initArray)
          }
          newArray.push(element)
        }
      })
      // console.log('ConvertSyncArray ' + JSON.stringify(newArray))
      Callback(null, newArray)
    },
    CalculateIconState(BinArray, InitialStateArray) {
      var NewState = BinArray
      var InitState = InitialStateArray
      var count = ''
      var count2 = ''
      InitState.reverse()
      InitState.forEach((element, index) => {
        count2 += '' + element
      })
      var InitStateResult = parseInt(count2, 2)
      NewState.reverse()
      NewState.forEach((element, index) => {
        count += '' + element
      })
      var NewStateResult = parseInt(count, 2)
      var hasStateChanged = ( InitStateResult - NewStateResult )
      if(hasStateChanged) {
        if(hasStateChanged === -3) {
          NewStateResult = 5
          if(NewState[1] === 1) {
            NewStateResult = 7
          }
        } else if(hasStateChanged === 3) {
          NewStateResult = 6
          if(NewState[1] === 1) {
            NewStateResult = 8
          }
        } else if(hasStateChanged === -1) {
          NewStateResult = 10
        } else if(hasStateChanged === -4) {
          NewStateResult = 9
        } else if(hasStateChanged === 4 || hasStateChanged === 1) {
          // NewStateResult = 11;  // for future feature
          NewStateResult = 0
        }
      } else {
        if(NewStateResult === 4) {
          NewStateResult = 2
        }
        if(NewStateResult === 6) {
          NewStateResult = 4
        }
      }
      InitState.reverse()
      // console.log('CalculateIconState ', JSON.stringify(NewStateResult))
      return NewStateResult
    },
    /**
    *  \brief  merge data new data into syncarray
    *  \param   {} || [] , [] , Callback
    *  \return  callback merged SyncArray
    */
    MergeSyncArray(NewData, CurrData, Callback) {
      let newArray = []
      CurrData.forEach((element, index) => {
        if(Number(element.sectionid) === Number(NewData[0].sectionid)) {
          let initialState = element.initialState
          let actionIconInitArray = element.actionIconInitArray
          this.ConvertSyncArray(NewData, actionIconInitArray, (err, rtn) => {
            if(err)
              console.log(err)
            else {
              if(rtn[0] !== undefined) {
                element = rtn[0]
                element.initialState = initialState
                element.actionIconInitArray = actionIconInitArray
                newArray.push(element)
              }
            }
          })
        } else {
          newArray.push(element)
        }
      })
           
      // console.log('MergeSyncArray ', JSON.stringify(newArray))
      Callback(null, newArray)
    },
    /**
    *  \brief  set the state of the checkboxes and the parameters for the object
    *  \param   Id
    *  \return  void
    */
    CheckBoxA(Id) {
      if($('#showA' + Id).prop('checked') && $('#showB' + Id).prop('checked')) {
        $('#showB' + Id).prop('checked', false)
        if(this.SyncArray !== undefined) {
          this.SyncArray.forEach((element, index) => {
            if(index === Id) {
              element.checkedWeb = true
              element.checkedCtrl = false
              this.SyncDirection(element)
            }
          })
        }
      } else if(!($('#showB' + Id).prop('checked')) && ($('#showA' + Id).prop('checked'))) {
        $('#showA' + Id).prop('checked', true)
        $('#showB' + Id).prop('checked', false)
        if(this.SyncArray !== undefined) {
          this.SyncArray.forEach((element, index) => {
            if(index === Id) {
              element.checkedWeb = true
              element.checkedCtrl = false
              this.SyncDirection(element)
            }
          })
        }
      } else if(!($('#showB' + Id).prop('checked')) && !($('#showA' + Id).prop('checked'))) {
        $('#showA' + Id).prop('checked', false)
        $('#showB' + Id).prop('checked', false)
        if(this.SyncArray !== undefined) {
          this.SyncArray.forEach((element, index) => {
            if(index === Id) {
              element.checkedWeb = false
              element.checkedCtrl = false
              this.SyncDirection(element)
            }
          })
        }
      }
    },
    /**
    *  \brief  set the state of the checkboxes and the parameters for the object
    *  \param   Id
    *  \return  void
    */
    CheckBoxB(Id) {
      if($('#showB' + Id).prop('checked') && $('#showA' + Id).prop('checked')) {
        $('#showA' + Id).prop('checked', false)
        if(this.SyncArray !== undefined) {
          this.SyncArray.forEach((element, index) => {
            if(index === Id) {
              element.checkedWeb = false
              element.checkedCtrl = true
              this.SyncDirection(element)
            }
          })
        }
      } else if(!($('#showB' + Id).prop('checked')) && !($('#showA' + Id).prop('checked'))) {
        $('#showA' + Id).prop('checked', false)
        $('#showB' + Id).prop('checked', false)
        if(this.SyncArray !== undefined) {
          this.SyncArray.forEach((element, index) => {
            if(index === Id) {
              element.checkedWeb = false
              element.checkedCtrl = false
              this.SyncDirection(element)
            }
          })
        }
      } else if(($('#showB' + Id).prop('checked')) && !($('#showA' + Id).prop('checked'))) {
        $('#showA' + Id).prop('checked', false)
        $('#showB' + Id).prop('checked', true)
        if(this.SyncArray !== undefined) {
          this.SyncArray.forEach((element, index) => {
            if(index === Id) {
              element.checkedWeb = false
              element.checkedCtrl = true
              this.SyncDirection(element)
            }
          })
        }
      }
    },
    /**
    *  \brief  sends a message to server about change in sync direction
    *  \param   Data
    *  \return  void
    */
    SyncDirection(Data) {
      let UseApp = false
      let UseCtrl = false
      let sectionId = 0
      let Msg = {}
      UseApp = Data.checkedWeb
      UseCtrl = Data.checkedCtrl
      sectionId = Data.sectionid

      Msg = { Category: 'Settings', Type: 'SyncDirection', Oper: 'Upd', Seq: '' + sectionId, UseApp: UseApp, UseCtrl: UseCtrl }
      console.debug('%c--> ' + JSON.stringify(Msg), 'color: purple')
      // console.debug('sync', Msg)
      this.SocketMessageSend(Msg)
    }
  }
}
</script>

<style lang="scss">
.sync {
  width: 70vw;
  margin: 0 auto;
  background: $color-white;
  border-radius: $application-base-border-radius;
  font-size: 12px; // media
  box-shadow: 0 1px 2px $color-grey-darker;

  .warning {
    background: $color-yellow;
    padding: 2px;
  }
  
  // change 'sync ok' text to green (future update)
  .ok {
    background: $color-green;
    padding: 2px;
  }

  &__spinner {
    @include spinner('after', 80px, 5px, $color-grey);
    &:after {
      display: block;
      margin: 10px auto 25px;
    }
  }
  &__status-wrapper {
    display: flex;
    align-items: center;
    margin: 0 3px;
  }

  &__status-icon {
    background: rgba($color-white, 30);
    padding: 5px;
    margin: 2px;  // media
    font-size: 18px; // media
    border-radius: $application-base-border-radius;
    cursor: pointer;
  }

  &__header {
    padding-top: 3px;

    &__warn {
      text-align: center;
      margin: 0 0 3px;
    }

    &__logo-and-title {
      padding-top: 0px;
      padding-left: 10px;
      font-size: 22px;

      strong {
        padding-left: 10px;
        text-align: center;
      }
    }
    &__button {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0px 20px;

      button {
        margin: 0;
      }
    }
  }

  &__sync-list {
    &-wrapper {
      max-height: 65vh;
      overflow-y: scroll;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        box-shadow: 0px 0px 5px $color-black;
      }
    }
    &__row {
      box-sizing: border-box;
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
      line-height: 18px;

      border-bottom: 1px solid $color-black;

      strong {
        text-align: center;
      }
      &--time {
        grid-template-columns: 27% 20% 33% 20%;
      }
      &--title-header > *:nth-child(odd) {
        border-top-left-radius: $application-base-border-radius;
        border-top-right-radius: $application-base-border-radius;
      }

      > * {
        box-sizing: border-box;
        padding: 0px;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        &:nth-child(odd) {
          background-color: lighten($color-grey, 20);
        }
        &.flex-row {
          flex-direction: row;
        }
      }
    }
  }
}

@media screen and (min-width: $bp-tablet) {
  .sync {
    max-width:  80%;
    font-size: 16px;
    &__status-icon {
      margin: 5px;
      font-size: 28px;
    }
  }
}
</style>
